module.exports = __webpack_public_path__ + "img/icon-team-type-5.646326f3.png";